<template>
    <div class="tile stack-l" :id="placeholder.name">
        <div class="tile-title">
            <h2>Placeholder {{placeholder.name | capitalize}}</h2>
        </div>
        <div class="tile-content">
            <div class="table-control">
                <table class="table table-hoverable">
                    <thead>
                    <tr>
                        <th>Property</th>
                        <th>Description</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="entity in placeholder.entities">
                        <tr v-if="placeholder.name !== entity.name">
                            <td colspan="3"><h3>{{ formatRoute(entity.route)}}</h3></td>
                        </tr>
                        <guide-notification-field
                            v-for="field in entity.fields"
                            :field="field"
                            :parent="entity"
                            :base-path="entity.route"
                            :key="getFieldLocation(entity.route, field)"/>
                    </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import GuideNotificationField from './guide-notification-field';

    export default {
        components: {GuideNotificationField},
        name: 'guide-notification-placeholder',
        props: {
            placeholder: {
                type: Object,
            },
        },
        methods: {
            getFieldLocation(route, field) {
                return `${route}.${field.name}`;
            },
            formatRoute(route) {
                return route.replace(/\./g, ' > ');
            },
        },
    };
</script>
